import PureSpinner from './PureSpinner'

export default PureSpinner
